/**
 * 프로모션 서비스
 */

import apiClient from './api';
import {
  Promotion,
  PromotionFilter,
  PromotionListResponse,
} from '../types/promotion';

export const promotionService = {
  /**
   * 프로모션 목록 조회
   */
  async getPromotions(filter: PromotionFilter = {}): Promise<PromotionListResponse> {
    const params = new URLSearchParams();
    
    if (filter.status) params.append('status', filter.status);
    if (filter.search) params.append('search', filter.search);
    if (filter.page) params.append('page', filter.page.toString());
    if (filter.limit) params.append('limit', filter.limit.toString());

    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: PromotionListResponse }>(`/admin/promotions?${params.toString()}`);
    // return response.data.data;

    // 임시: 더미 데이터 반환
    return {
      promotions: [],
      pagination: {
        current_page: 1,
        total_pages: 1,
        total_count: 0,
        limit: 20,
      },
    };
  },

  /**
   * 프로모션 상세 조회
   */
  async getPromotion(id: number): Promise<Promotion> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.get<{ data: { promotion: Promotion } }>(`/admin/promotions/${id}`);
    // return response.data.data.promotion;

    throw new Error('Not implemented');
  },

  /**
   * 프로모션 등록
   */
  async createPromotion(data: Partial<Promotion>): Promise<Promotion> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.post<{ data: { promotion: Promotion } }>('/admin/promotions', data);
    // return response.data.data.promotion;

    throw new Error('Not implemented');
  },

  /**
   * 프로모션 수정
   */
  async updatePromotion(id: number, data: Partial<Promotion>): Promise<Promotion> {
    // TODO: 백엔드 API 구현 후 연동
    // const response = await apiClient.put<{ data: { promotion: Promotion } }>(`/admin/promotions/${id}`, data);
    // return response.data.data.promotion;

    throw new Error('Not implemented');
  },

  /**
   * 프로모션 삭제
   */
  async deletePromotion(id: number): Promise<void> {
    // TODO: 백엔드 API 구현 후 연동
    // await apiClient.delete(`/admin/promotions/${id}`);

    throw new Error('Not implemented');
  },
};

